export const imports = {
  'index.mdx': () =>
    import(/* webpackPrefetch: true, webpackChunkName: "index" */ 'index.mdx'),
  'components/ActionBar/ActionBar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-action-bar-action-bar" */ 'components/ActionBar/ActionBar.mdx'
    ),
  'components/Alert/Alert.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-alert-alert" */ 'components/Alert/Alert.mdx'
    ),
  'components/Avatar/Avatar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-avatar-avatar" */ 'components/Avatar/Avatar.mdx'
    ),
  'components/Badge/Badge.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-badge-badge" */ 'components/Badge/Badge.mdx'
    ),
  'components/BlurBackground/BlurBackground.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-blur-background-blur-background" */ 'components/BlurBackground/BlurBackground.mdx'
    ),
  'components/Button/Button.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-button-button" */ 'components/Button/Button.mdx'
    ),
  'components/Card/Card.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-card-card" */ 'components/Card/Card.mdx'
    ),
  'components/Clipboard/Clipboard.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-clipboard-clipboard" */ 'components/Clipboard/Clipboard.mdx'
    ),
  'components/Countdown/Countdown.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-countdown-countdown" */ 'components/Countdown/Countdown.mdx'
    ),
  'components/Collapsible/Collapsible.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-collapsible-collapsible" */ 'components/Collapsible/Collapsible.mdx'
    ),
  'components/Dialog/Dialog.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-dialog-dialog" */ 'components/Dialog/Dialog.mdx'
    ),
  'components/Dimmer/Dimmer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-dimmer-dimmer" */ 'components/Dimmer/Dimmer.mdx'
    ),
  'components/Dropdown/Dropdown.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-dropdown-dropdown" */ 'components/Dropdown/Dropdown.mdx'
    ),
  'components/ExpansionPanel/ExpansionPanel.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-expansion-panel-expansion-panel" */ 'components/ExpansionPanel/ExpansionPanel.mdx'
    ),
  'components/Flex/Flex.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-flex-flex" */ 'components/Flex/Flex.mdx'
    ),
  'components/HoverActions/HoverActions.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-hover-actions-hover-actions" */ 'components/HoverActions/HoverActions.mdx'
    ),
  'components/Grid/grid.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-grid-grid" */ 'components/Grid/grid.mdx'
    ),
  'components/Img/Img.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-img-img" */ 'components/Img/Img.mdx'
    ),
  'components/Icons/Icons.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-icons-icons" */ 'components/Icons/Icons.mdx'
    ),
  'components/Layer/Layer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-layer-layer" */ 'components/Layer/Layer.mdx'
    ),
  'components/Layer/LayerCondensed.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-layer-layer-condensed" */ 'components/Layer/LayerCondensed.mdx'
    ),
  'components/Lists/Lists.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-lists-lists" */ 'components/Lists/Lists.mdx'
    ),
  'components/Modal/Modal.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-modal-modal" */ 'components/Modal/Modal.mdx'
    ),
  'components/Pagination/Pagination.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-pagination-pagination" */ 'components/Pagination/Pagination.mdx'
    ),
  'components/Placeholder/Placeholder.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-placeholder-placeholder" */ 'components/Placeholder/Placeholder.mdx'
    ),
  'components/Segment/Segment.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-segment-segment" */ 'components/Segment/Segment.mdx'
    ),
  'components/Section/Section.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-section-section" */ 'components/Section/Section.mdx'
    ),
  'components/Section/SectionTitle.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-section-section-title" */ 'components/Section/SectionTitle.mdx'
    ),
  'components/Styled/Styled.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-styled-styled" */ 'components/Styled/Styled.mdx'
    ),
  'components/Toast/Toast.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-toast-toast" */ 'components/Toast/Toast.mdx'
    ),
  'components/Tooltip/Tooltip.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-tooltip-tooltip" */ 'components/Tooltip/Tooltip.mdx'
    ),
  'components/Typography/Typography.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-typography-typography" */ 'components/Typography/Typography.mdx'
    ),
  'components/ProgressBar/ProgressBar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-progress-bar-progress-bar" */ 'components/ProgressBar/ProgressBar.mdx'
    ),
  'hooks/use-window-size/useWindowSize.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "hooks-use-window-size-use-window-size" */ 'hooks/use-window-size/useWindowSize.mdx'
    ),
  'utils/colors/colors.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "utils-colors-colors" */ 'utils/colors/colors.mdx'
    ),
  'utils/gradients/gradients.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "utils-gradients-gradients" */ 'utils/gradients/gradients.mdx'
    ),
  'components/Form/Checkbox/Checkbox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-checkbox-checkbox" */ 'components/Form/Checkbox/Checkbox.mdx'
    ),
  'components/Form/DatePicker/DatePicker.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-date-picker-date-picker" */ 'components/Form/DatePicker/DatePicker.mdx'
    ),
  'components/Form/InputCpf/InputCpf.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-cpf-input-cpf" */ 'components/Form/InputCpf/InputCpf.mdx'
    ),
  'components/Form/InputDateFallback/InputDateFallback.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-date-fallback-input-date-fallback" */ 'components/Form/InputDateFallback/InputDateFallback.mdx'
    ),
  'components/Form/InputDiscount/InputDiscount.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-discount-input-discount" */ 'components/Form/InputDiscount/InputDiscount.mdx'
    ),
  'components/Form/InputFake/InputFake.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-fake-input-fake" */ 'components/Form/InputFake/InputFake.mdx'
    ),
  'components/Form/InputFromTo/InputFromTo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-from-to-input-from-to" */ 'components/Form/InputFromTo/InputFromTo.mdx'
    ),
  'components/Form/InputMask/InputMask.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-mask-input-mask" */ 'components/Form/InputMask/InputMask.mdx'
    ),
  'components/Form/Input/Input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-input" */ 'components/Form/Input/Input.mdx'
    ),
  'components/Form/InputMoney/InputMoney.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-money-input-money" */ 'components/Form/InputMoney/InputMoney.mdx'
    ),
  'components/Form/InputNumeric/InputNumeric.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-input-numeric-input-numeric" */ 'components/Form/InputNumeric/InputNumeric.mdx'
    ),
  'components/Form/RadioButton/RadioButton.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-radio-button-radio-button" */ 'components/Form/RadioButton/RadioButton.mdx'
    ),
  'components/Form/RichTextEditor/RichTextEditor.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-rich-text-editor-rich-text-editor" */ 'components/Form/RichTextEditor/RichTextEditor.mdx'
    ),
  'components/Form/Select/Select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-select-select" */ 'components/Form/Select/Select.mdx'
    ),
  'components/Form/TextArea/TextArea.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-text-area-text-area" */ 'components/Form/TextArea/TextArea.mdx'
    ),
  'components/Form/Switch/Switch.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "components-form-switch-switch" */ 'components/Form/Switch/Switch.mdx'
    ),
}
